const initPatient = {
    id: null,
    surname: null,
    forename: null,
    birth_date: null,
    gender: null,
    race: null,
    address: null,
    nhs_id: null,
    post_code: null,
    second_address: null,
    country: null,
    region: null,
    is_registered: false,
    town: null,
    pharmacy_site_id: null,
    consultant_id: null,
    collection_centre_id: null,
    first_blood_sample_date: null,
    last_blood_sample_date: null,
    next_due_date: null,
    blood_testing_frequency: null,
    status: false,
    dont_send_mails: false,
    health_information: {
        cnrd_date: null,
        up_to_including_date: null,
        normal_blood_sample_day: null,
        is_checked: false,
        is_locked: false,
        is_with_ben: false,
        cnrd_entry_found: false,
    },
    diagnosis: {
        diagnosis: null,
        is_prescribed_clozapine: false,
        is_with_sch: false,
        is_with_park: false,
        is_chemo_or_observation: false,
        is_under_monitoring: false,
        is_with_bone_disease: false,
        is_in_patient: false,
        previous_anti_psychotics: null,
        ward_name: null,
        suspension: false,
    },
    dispensing: {
        id: null,
        permitted: false,
        has_schedule: false,
        has_treatment_break: false,
        treatment_break_date: null,
        updated_at: null,
        timeLine: [
            {
                id: null,
                patient_id: null,
                memo_type: 'dispensing_stages',
                created_by_id: null,
                action: 'Dispensing Permitted',
                memo_date: new Date(),
                memo_text: 'New Patient Permitted',
                additional_data: { type: null },
                created_at: new Date(),
                updated_at: new Date(),
            },
        ],
    },
    dms_id: null,
};

const NotificationPatient = {
    namespaced: true,
    state: {
        patient: initPatient,
        patientSnapShot: initPatient,
        updatedProps: [],
    },
    mutations: {
        SET_PATIENT_PROPERTY(state, data) {
            _.set(state, data.property, data.value);
        },
        SET_PATIENT(state, data) {
            state.patient = data;
        },
        SET_PATIENT_SNAP_SHOT(state, data) {
            state.patientSnapShot = data;
        },
        SET_UPDATED_PROPS(state, props) {
            state.updatedProps = props;
        },
    },
    actions: {
        loadPatient({ commit }, data) {
            commit('SET_PATIENT', data);
        },
        loadPatientSnapShot({ commit }, data) {
            commit('SET_PATIENT_SNAP_SHOT', data);
        },
        setUpdatedProps({ commit }, props) {
            commit('SET_UPDATED_PROPS', props);
        },
        loadAddress({ commit, state }) {
            commit('SET_PATIENT_PROPERTY', { property: 'patient.county', value: state.patient.region });
            commit('SET_PATIENT_PROPERTY', { property: 'patient.country', value: state.patient.country });
            commit('SET_PATIENT_PROPERTY', { property: 'patient.town', value: state.patient.town });
        },
    },
};

export default NotificationPatient;
